import { AnyAction } from 'redux';
import {
  App,
  Produkt,
  Produktlinie,
  Vorbelegungdaten,
  ZusatzoptionItem,
} from '@ps20-frontend/frontend-models';
import { produktReducer } from '@ps20-frontend/reducers';
import { GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { RsVermieterActions } from '../rs-vermietung-actions.service';

const VERMIETER_RS = 'RS000442';

export function rsVermietungProduktReducer(
  sectionState: Produkt = null,
  action: AnyAction,
): Produkt {
  const newSectionState = produktReducer(sectionState, action, App.RS_VERMIETUNG);
  switch (action.type) {
    case RsVermieterActions.PRODUKTLINIEN_CHANGED: {
      const produktlinien: Produktlinie[] = action.payload;
      produktlinien[0].selected = true;
      produktlinien[0].zusatzoptionen = [];
      return { ...newSectionState, produktlinien };
    }
    case GlobalActions.VORBELEGUNG_FOR_BEIBEHALTUNG_REQUESTED: {
      const actionPayload: Vorbelegungdaten = action.payload;
      if (
        actionPayload.forApp === App.RS_VERMIETUNG &&
        newSectionState !== null &&
        newSectionState?.produktlinien?.length > 0
      ) {
        const selectedProduktlinie = newSectionState.produktlinien.find(pl => pl.selected);
        if (selectedProduktlinie) {
          actionPayload.vorvertragBausteinList?.forEach(ele => {
            if (ele.fachschluessel === VERMIETER_RS) {
              const defaultZusatzoption: ZusatzoptionItem = {
                bausteinAnpassungsfaktor: ele.bausteinAnpassungsfaktor,
                deltafaktor: ele.deltafaktor,
                plzFaktor: ele.plzFaktor,
              } as ZusatzoptionItem;
              selectedProduktlinie.zusatzoptionen.push(defaultZusatzoption);
            }
          });
        }
      }
      return newSectionState;
    }
    default:
      return newSectionState;
  }
}
